import React from "react";
import { useTranslation } from "react-i18next";

import { SdkConfiguration, Test } from "./BmsCommonInterfaces";
import DiagnosticsTestsForm from "./diagnostics/DiagnosticsTestsForm";
import BmsSectionHeader from "./form-components/BmsSectionHeader";

interface FormValues {
    sdkConfiguration: SdkConfiguration;
    platform: string;
}

interface Props {
    formValues: FormValues;
    setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
    showAdvanced: boolean;
}

const SdkConfigurationForm: React.FC<Props> = ({ formValues, setFormValues }) => {
    const { t } = useTranslation();

    const updateFormValues = (updateFn: (formValues: FormValues) => FormValues) => {
        setFormValues((previousFormValues) => updateFn({ ...previousFormValues }));
    };

    const handleTestsChange = (tests: Test[]) => {
        updateFormValues((previousFormValues) => {
            const { sdkConfiguration } = previousFormValues;

            return { ...previousFormValues, sdkConfiguration: { ...sdkConfiguration, tests: tests } };
        });
    };

    return (
        <div>
            <BmsSectionHeader
                labelKey={t("Configuration.common.headers.diagnosticsTests")}
                toolTipContent={t("Configuration.tooltips.common.diagnosticsTests")}
            />
            <div>
                <DiagnosticsTestsForm
                    currentEnabledTests={formValues.sdkConfiguration.tests}
                    onTestChange={handleTestsChange}
                    platform={"sdk"}
                />
            </div>
        </div>
    );
};

export default SdkConfigurationForm;
